import { render, staticRenderFns } from "./EnvTag.vue?vue&type=template&id=26138416&scoped=true"
import script from "./EnvTag.vue?vue&type=script&lang=js"
export * from "./EnvTag.vue?vue&type=script&lang=js"
import style0 from "./EnvTag.vue?vue&type=style&index=0&id=26138416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26138416",
  null
  
)

export default component.exports